// Central bilingual content for the Libyan Flag Company website.
export const SITE = {
  url: 'https://libya-flag.ly',
  email: 'info@libya-flag.ly',
  phone: '+218 91 210 2066',
  phoneHref: '+218912102066',
};

export const MATERIALS = [
  { code: 'LDPE', ar: 'البولي إيثيلين منخفض الكثافة', en: 'Low-Density Polyethylene' },
  { code: 'LLDPE', ar: 'البولي إيثيلين الخطي منخفض الكثافة', en: 'Linear Low-Density Polyethylene' },
  { code: 'HDPE', ar: 'البولي إيثيلين عالي الكثافة', en: 'High-Density Polyethylene' },
  { code: 'PP', ar: 'البولي بروبيلين', en: 'Polypropylene' },
  { code: 'PVC', ar: 'البولي فينيل كلوريد', en: 'Polyvinyl Chloride' },
  { code: 'PET', ar: 'البولي إيثيلين تيرفثالات', en: 'Polyethylene Terephthalate' },
  { code: 'PS / GPPS / HIPS', ar: 'البولي ستايرين', en: 'Polystyrene' },
  { code: 'ABS', ar: 'أكريلونيتريل بوتادايين ستايرين', en: 'Acrylonitrile Butadiene Styrene' },
  { code: 'EVA', ar: 'إيثيلين فينيل أسيتات', en: 'Ethylene Vinyl Acetate' },
  { code: 'PC', ar: 'البولي كربونات', en: 'Polycarbonate' },
  { code: 'PA / Nylon', ar: 'البولي أميد (النايلون)', en: 'Polyamide' },
];

export const MARKETS = [
  { ar: 'تركيا', en: 'Turkey' },
  { ar: 'الصين', en: 'China' },
  { ar: 'الإمارات العربية المتحدة', en: 'United Arab Emirates' },
  { ar: 'السعودية', en: 'Saudi Arabia' },
  { ar: 'مصر', en: 'Egypt' },
  { ar: 'الهند', en: 'India' },
  { ar: 'كوريا الجنوبية', en: 'South Korea' },
  { ar: 'دول أوروبا', en: 'European countries' },
];

export const APPLICATIONS = {
  ar: [
    'الأكياس البلاستيكية',
    'خزانات المياه الكبيرة (تقنية النفخ الحديثة)',
    'الأفلام البلاستيكية',
    'العبوات',
    'الأنابيب',
    'الكراسي والمنتجات البلاستيكية الصلبة',
    'أكياس الرافية',
    'القوارير',
    'المنتجات المصنعة بالحقن',
    'تطبيقات صناعية أخرى',
  ],
  en: [
    'Plastic bags',
    'Large water tanks (advanced blow molding)',
    'Plastic films',
    'Packaging',
    'Pipes',
    'Plastic chairs & rigid products',
    'Raffia bags',
    'Bottles',
    'Injection-molded products',
    'Various industrial applications',
  ],
};

export const CONTENT = {
  ar: {
    dir: 'rtl',
    lang: 'ar',
    nav: {
      home: 'الرئيسية',
      about: 'من نحن',
      materials: 'المواد الخام',
      markets: 'الأسواق',
      applications: 'الاستخدامات',
      contact: 'تواصل معنا',
      cta: 'تواصل معنا',
    },
    hero: {
      eyebrow: 'استيراد موثوق من أسواق عالمية متنوعة',
      title: 'شركة علم ليبيا لاستيراد المواد الخام',
      subtitle: 'نستورد المواد الخام البلاستيكية من الأسواق العالمية ونوفرها لتلبية احتياجات مختلف قطاعات الصناعات البلاستيكية في السوق الليبي.',
      ctaPrimary: 'المواد الخام',
      ctaSecondary: 'تواصل معنا',
      badges: ['مصادر استيراد متنوعة', 'مواصفات فنية موثوقة', 'شراكات عالمية'],
    },
    about: {
      title: 'من نحن',
      kicker: 'نبذة عن الشركة',
      paragraphs: [
        'شركة علم ليبيا لاستيراد المواد الخام هي شركة متخصصة في استيراد المواد الخام البلاستيكية من الأسواق العالمية، وتوفيرها لتلبية احتياجات مختلف قطاعات الصناعات البلاستيكية في السوق الليبي.',
        'نتعامل مع مجموعة واسعة من المواد الخام البلاستيكية ذات الاستخدامات المتعددة، ونستوردها من مصادر وأسواق عالمية متنوعة وفقًا لمتطلبات واحتياجات السوق.',
      ],
    },
    strengths: {
      title: 'لماذا علم ليبيا',
      items: [
        { title: 'تنويع مصادر الاستيراد', desc: 'شبكة توريد من أسواق عالمية متعددة تمنحنا مرونة في تلبية مختلف المتطلبات.' },
        { title: 'فهم احتياجات السوق', desc: 'معرفة دقيقة بمتطلبات قطاع الصناعات البلاستيكية في السوق الليبي.' },
        { title: 'علاقات طويلة الأمد', desc: 'شراكات تجارية مستقرة مع موردين حول العالم تضمن استمرارية التوريد.' },
      ],
    },
    materials: {
      title: 'أهم المواد الخام',
      kicker: 'المواد التي نستوردها',
      intro: 'تشمل المواد التي نستوردها، على سبيل المثال لا الحصر:',
      note: 'بالإضافة إلى مجموعة من الإضافات والمواد المساعدة المستخدمة في الصناعات البلاستيكية.',
    },
    markets: {
      title: 'الأسواق العالمية',
      kicker: 'من أين نستورد',
      intro: 'نستورد المواد الخام من مجموعة متنوعة من الأسواق العالمية، من بينها:',
      note: 'ويتيح لنا تنوع مصادر الاستيراد التعامل مع احتياجات مختلفة من حيث نوع المادة، المواصفات الفنية، بلد المنشأ، والكمية المطلوبة.',
    },
    applications: {
      title: 'مجالات الاستخدام',
      kicker: 'أين تُستخدم موادنا',
      intro: 'تدخل المواد الخام التي نستوردها في العديد من الصناعات والتطبيقات البلاستيكية، ومنها:',
    },
    vision: {
      kicker: 'رؤيتنا',
      title: 'رؤيتنا',
      text: 'نسعى إلى أن نكون من الشركات المتخصصة والموثوقة في مجال استيراد المواد الخام البلاستيكية في ليبيا، من خلال تنويع مصادر الاستيراد، وفهم احتياجات السوق، وبناء علاقات تجارية طويلة الأمد مع شركائنا حول العالم.',
    },
    warehouse: {
      title: 'من مستودعاتنا',
      kicker: 'مواد جاهزة للتوريد',
      desc: 'مواد خام بلاستيكية من موردين عالميين موثوقين، جاهزة للتوريد لمصانع الصناعات البلاستيكية في ليبيا.',
    },
    contact: {
      title: 'تواصل معنا',
      kicker: 'نحن هنا لخدمتكم',
      desc: 'للاستفسارات، طلبات التوريد، أو التعاون التجاري، يسعدنا تواصلكم معنا عبر قنوات الاتصال التالية:',
      emailLabel: 'البريد الإلكتروني',
      phoneLabel: 'رقم الهاتف',
      formTitle: 'أرسل لنا رسالة',
      formName: 'الاسم الكامل',
      formEmail: 'البريد الإلكتروني',
      formMessage: 'رسالتك',
      formSubmit: 'إرسال عبر البريد الإلكتروني',
    },
    footer: {
      tagline: 'استيراد المواد الخام البلاستيكية لخدمة السوق الليبي',
      rights: 'جميع الحقوق محفوظة',
      quickLinks: 'روابط سريعة',
    },
  },
  en: {
    dir: 'ltr',
    lang: 'en',
    nav: {
      home: 'Home',
      about: 'About',
      materials: 'Materials',
      markets: 'Markets',
      applications: 'Applications',
      contact: 'Contact',
      cta: 'Contact Us',
    },
    hero: {
      eyebrow: 'Trusted Sourcing from Global Markets',
      title: 'Libyan Flag Company',
      subtitle: 'We import plastic raw materials from international markets, serving the needs of various sectors of the Libyan plastics industry.',
      ctaPrimary: 'Our Materials',
      ctaSecondary: 'Contact Us',
      badges: ['Diversified Sourcing', 'Reliable Specifications', 'Global Partnerships'],
    },
    about: {
      title: 'About Us',
      kicker: 'Company Overview',
      paragraphs: [
        'Libyan Flag Company for Raw Materials Import is a specialized company engaged in the import of plastic raw materials from international markets, serving the needs of various sectors of the Libyan plastics industry.',
        'We handle a wide range of plastic raw materials with diverse applications and import them from different international markets according to market requirements and customer needs.',
      ],
    },
    strengths: {
      title: 'Why Libyan Flag Company',
      items: [
        { title: 'Diversified Sourcing', desc: 'A supply network spanning multiple global markets, giving us flexibility to meet different requirements.' },
        { title: 'Market Understanding', desc: 'A precise understanding of what the Libyan plastics industry needs.' },
        { title: 'Long-Term Partnerships', desc: 'Stable business relationships with suppliers worldwide that ensure continuity of supply.' },
      ],
    },
    materials: {
      title: 'Main Raw Materials',
      kicker: 'What We Import',
      intro: 'Our imported materials include, but are not limited to:',
      note: 'In addition to various additives and processing materials used in plastic manufacturing.',
    },
    markets: {
      title: 'Global Markets',
      kicker: 'Where We Import From',
      intro: 'We import plastic raw materials from a variety of international markets, including:',
      note: 'Our diversified sourcing network enables us to handle different requirements in terms of material type, technical specifications, country of origin, and required quantities.',
    },
    applications: {
      title: 'Applications',
      kicker: 'Where Our Materials Are Used',
      intro: 'The raw materials we import are used across a wide range of plastic products and applications, including:',
    },
    vision: {
      kicker: 'Our Vision',
      title: 'Our Vision',
      text: 'Our goal is to establish Libyan Flag Company as a specialized and trusted company in the Libyan plastic raw materials import sector by diversifying our international sourcing markets, understanding market requirements, and building long-term business relationships with partners around the world.',
    },
    warehouse: {
      title: 'From Our Warehouse',
      kicker: 'Ready to Supply',
      desc: 'Plastic raw materials from trusted global suppliers, ready to supply plastics manufacturers across Libya.',
    },
    contact: {
      title: 'Contact Us',
      kicker: 'We Are Here to Serve You',
      desc: 'For inquiries, supply requests, or business cooperation, please feel free to reach us through the following channels:',
      emailLabel: 'Email',
      phoneLabel: 'Phone',
      formTitle: 'Send Us a Message',
      formName: 'Full Name',
      formEmail: 'Email Address',
      formMessage: 'Your Message',
      formSubmit: 'Send via Email',
    },
    footer: {
      tagline: 'Importing Plastic Raw Materials for the Libyan Market',
      rights: 'All rights reserved',
      quickLinks: 'Quick Links',
    },
  },
};
